const fetchBannersQuery = (params: {
    affiliateId: number,
    categories: string,
    sectionId: number,
    cookieAccept: string,
    hasVast: number
}, baseUrl: string): string => {
    return baseUrl + '/adserver/banners' +
        '?affiliateId=' + (isNaN(+params.affiliateId) ? 0 : +params.affiliateId) +
        '&categories=' + encodeURIComponent(params.categories) +
        '&sectionId=' + (isNaN(+params.sectionId) ? 0 : +params.sectionId) +
        '&cookieAccept=' + encodeURIComponent(params.cookieAccept) +
        '&hasVast=' + encodeURIComponent(params.hasVast);
};

export { fetchBannersQuery }